module.exports = __webpack_public_path__ + "static/img/PE@3x.7ca9673d.jpg";